import { useCallback, useEffect, useRef } from 'react';
import moment from 'moment';

import { useAddTimeoutID } from '../../../actions/alert';
import { PopupType } from '../../../reducers/alert';
import { checkDurationOfFlight, checkTocPoint } from '../../../service/alert/tools';

export const useRepeatTimeout = (
    { type, allowed, legId, timeoutID, interval, timeMS, nextAlert },
    timeoutHandler,
    needUpdate,
    toggleUpdate
) => {
    const firstRender = useRef(true);

    const addTimeoutID = useAddTimeoutID();

    const handleTimeoutOver = useCallback(() => {
        timeoutHandler(PopupType[type], legId);
    }, [timeoutHandler, type, legId]);

    const reInitTimeout = useCallback((nextAlert, nowUTC) => {
        const restTime = nextAlert ? moment.utc(nowUTC).diff(nextAlert, 'milliseconds') : 0;

        return restTime < 0 ? 0 : restTime;
    }, []);

    const isTocPointAto = checkTocPoint();
    const isLongFlight = checkDurationOfFlight();

    useEffect(() => {
        if (isTocPointAto || isLongFlight) {
            toggleUpdate(true);
        }
    }, [isTocPointAto, isLongFlight]);

    useEffect(() => {
        if ((firstRender.current || needUpdate) && timeoutID) {
            const nowUTC = moment.utc();
            const timeoutMS = reInitTimeout(nextAlert, nowUTC);
            const timeoutId = setTimeout(handleTimeoutOver, timeoutMS);
            addTimeoutID({ legId, type, timeoutId, date: nowUTC.add(timeoutMS, 'milliseconds').toISOString() });
        }
        firstRender.current = false;
    }, [needUpdate]);

    return useCallback(
        (needUpdate) => {
            if (allowed && (needUpdate || !timeoutID)) {
                toggleUpdate(false);
                const nextAlertDate = moment
                    .utc()
                    .add(timeMS || interval, 'milliseconds')
                    .toISOString();
                const restTime = moment.utc(nextAlertDate).diff(moment.utc(), 'milliseconds');
                const timeoutId = setTimeout(handleTimeoutOver, restTime);
                addTimeoutID({ legId, type, timeoutId, date: nextAlertDate });
            }
        },
        [type, allowed, legId, timeoutID, interval, timeMS, nextAlert, timeoutHandler]
    );
};
